module.exports = __webpack_public_path__ + "img/ic-success.7dd19416.svg";